<template>
  <window-layout width="640px">
    <h1>{{ $t('v.logout.title') }}</h1>

    <v-card>
      <v-card-title>{{ $t('v.logout.titleAttention') }}</v-card-title>

      <v-card-body>
        <p>
          {{ $t('v.logout.message') }}
          <ol>
              <li>{{ $t('v.logout.messageListItem1') }}</li>
              <li>{{ $t('v.logout.messageListItem2') }}</li>
              <li>{{ $t('v.logout.messageListItem3') }}</li>
          </ol>
        </p>

        <v-row justify="center">
          <v-button theme="primary" @click="redirectToHome">{{ $t('v.logout.buttonHome') }}</v-button>
        </v-row>
      </v-card-body>
    </v-card>
  </window-layout>
</template>

<script>
import VCard from '@/components/common/VCard.vue'
import VCardTitle from '@/components/common/VCardTitle.vue'
import VCardBody from '@/components/common/VCardBody.vue'
import VRow from '@/components/common/VRow.vue'
import * as types from '@/store/types'
import WindowLayout from '@/layouts/Window.vue'

export default {
  name: 'Logout',
  components: {
    WindowLayout,
    VCard,
    VCardTitle,
    VCardBody,
    VRow
  },
  methods: {
    redirectToHome() {
      this.$router.push({ name: 'home' })
    }
  },

  created() {
    const { prompt } = this.$route.query

    if (prompt && (prompt === 'select_account' || prompt === 'consent')) {
      this.$store.dispatch(types.SET_LOCAL_PROMPT, { value: prompt })
    }
  }
}
</script>

<style>
</style>
